<template>
  <v-container fluid>
    <v-card class="pa-6">
      <!-- <v-card class="ma-5" elevation="0"> -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Trademark Docket</v-card-title>
        </v-col>
        <v-col align="right" cols="12" md="6" class="d-flex justify-end mb-6 mt-2">
          <!-- <xlsx-workbook @change="onChange" @created="onCreated">
            <xlsx-sheet
              :collection="sheet.data"
              v-for="sheet in sheets"
              :key="sheet.name"
              :sheet-name="sheet.name"
            />
            <xlsx-download :filename="exportleavequota">
              <v-btn outlined rounded class="btnexport">
                <span>Export</span>
                <v-icon small center>mdi-download</v-icon>
              </v-btn>
            </xlsx-download>
          </xlsx-workbook> -->
          <v-btn @click="exportExcel" outlined rounded class="btnexport">
            <span>Export</span>
            <v-icon small center>mdi-download</v-icon>
          </v-btn>
          <xlsx-workbook ref="workbook" @change="onChange" v-show="excelData.length > 0">
            <xlsx-sheet :collection="excelData" sheet-name="Docket_Trademark" />
            <xlsx-download ref="xlsxDownload" filename="Docket_Trademark.xlsx" />
          </xlsx-workbook>
          <v-btn :disabled="!authorize_add" @click="openAppointmentadd()" rounded color="#0A7EA5" dark
            class="mb-2 ml-2">
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="2">
          Work Type
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              searchdocumenttype = '';
            })
            " v-model="searchdocumenttype" :items="documenttype_list" item-text="documenttype_code"
            item-value="documenttype_id" outlined dense></v-autocomplete>
          <!-- @change="onSearchPagination" -->
        </v-col>
        <v-col cols="12" md="4">
          Trademark Name
          <v-text-field class="widthsizesearch" v-model="searchtrademark_name" outlined dense></v-text-field>
          <!-- v-on:keyup.enter="onSearchPagination" -->
        </v-col>
        <v-col cols="4" md="2">
          Status
          <v-select v-model="statusSearch" :items="statuslist" item-text="status_name" item-value="status_value"
            outlined dense clearable @click:clear="
              $nextTick(() => {
                statusSearch = 0;
              })
              "></v-select>
        </v-col>
        <v-col cols="12" md="3">
          Quotation
          <v-text-field class="widthsizesearch" v-model="searchquotation" outlined dense clearable
            @click:clear="$nextTick(() => { searchquotation = ''; })"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mt-n7">
        <v-col cols="12" md="2">
          <v-row>
            <v-col cols="12" md="12">
              File No.
              <v-text-field class="widthsizesearch" v-model="searchfile_no" outlined dense></v-text-field>
              <!-- v-on:keyup.enter="onSearchPagination" -->
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row>
            <v-col cols="12" md="8">
              Application No.
              <v-text-field class="widthsizesearch" v-model="searchapp_no" outlined dense></v-text-field>
              <!-- v-on:keyup.enter="onSearchPagination" -->
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="7">
          <v-row>
            <v-col cols="12" md="3" class="d-flex justify-center align-center">
              <h3>Final Deadline :</h3>
            </v-col>

            <v-col cols="12" md="4">
              From
              <v-menu v-model="menuadddatefrom" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290" max-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field clearable @click:clear="
                    $nextTick(() => {
                      searchdatefromS = null;
                      searchdatefrom = null;
                      searchdateto = null;
                      searchdatetoPicker = null;
                      // onSearchPagination();
                    })
                    " v-model="searchdatefrom" persistent-hint hint="Format DD/MM/YYYY" append-icon="mdi-calendar"
                    v-bind="attrs" v-on="on" outlined dense readonly></v-text-field>
                  <!-- @keydown.enter="onSearchPagination" -->
                </template>

                <v-date-picker v-model="searchdatefromS" @input="
                  () => {
                    searchdatefrom = formatDateToDDMMYYYY(searchdatefromS);
                    menuadddatefrom = false;
                    // onSearchPagination();
                  }
                "></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              To
              <v-menu v-model="menuadddateto" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290" max-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field clearable @click:clear="
                    $nextTick(() => {
                      searchdatefromS = null;
                      searchdatefrom = null;
                      searchdateto = null;
                      searchdatetoPicker = null;
                      // onSearchPagination();
                    })
                    " v-model="searchdateto" persistent-hint hint="Format DD/MM/YYYY" append-icon="mdi-calendar"
                    v-bind="attrs" v-on="on" outlined dense readonly></v-text-field>
                  <!-- @keydown.enter="onSearchPagination" -->
                </template>

                <v-date-picker v-model="searchdatetoPicker" @input="
                  () => {
                    searchdateto = formatDateToDDMMYYYY(searchdatetoPicker);
                    menuadddateto = false;
                    // onSearchPagination();
                  }
                "></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn large class="mt-5" icon @click="onSearchPagination" rounded :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }" dark>
                <v-icon center>mdi-magnify</v-icon>
              </v-btn></v-col>
          </v-row>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <!-- <v-aable
          :sort-by="['documenttype_code']"
          :items-per-page-options="pageSizes"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 100, -1],
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              :disabled="!authorize_edit"
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
              @click="openeditItem(item.appointment_id)"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              :disabled="!authorize_del"
              class="ml-3"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
        <v-progress-linear
          indeterminate
          color="teal"
          v-if="load_bg"
        ></v-progress-linear> -->

        <!-- Pagination Section -->
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <div style="width: 150px">
            <v-select v-model="itemsPerPage" @change="onSearchPagination" :items="item_per_page_list"
              label="Items per page" dense outlined hide-details></v-select>
          </div>

          <v-btn v-if="selectedItems.length > 0" @click="onDialogPayMent()" color="#0A7EA5" rounded dark class="mb-2"
            :disabled="!authorize_add">
            <span>Payment Request</span>
          </v-btn>
        </div>

        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="Number(totalItems)"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait" item-key="appointment_id" show-select
            v-model="selectedItems" :return-object="false">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>
            <template v-slot:[`item.documenttype_actions`]="{ item }">
              <div class="doc-type-checkbox-container" v-if="item.documenttype_actions.length > 0">
                <v-checkbox v-for="action in item.documenttype_actions" :key="action.id" :label="action.name"
                  :input-value="Number(action.documenttype_follow) === 1"
                  @change="(val) => onActionChange(item, action, val)" hide-details dense
                  class="doc-type-checkbox mb-1 mt-1"></v-checkbox>
              </div>
            </template>

            <template v-slot:[`item.user_note`]="{ item }">
              <div class="note-container" @click="startEditingNote(item)">
                <v-text-field v-if="item.editing_note" v-model="item.user_note" dense hide-details solo flat
                  :outlined="false" class="editable-note editing" @blur="finishEditingNote(item)"
                  @keydown.enter="finishEditingNote(item)" ref="noteField"></v-text-field>

                <div v-else class="note-display">
                  <span>{{ item.user_note || "" }}</span>
                  <v-icon small class="ml-1">mdi-pencil</v-icon>
                </div>
              </div>
            </template>
            <!-- Invoice / Receipt No. : ขึ้นบรรทัดใหม่แทน comma -->
            <template v-slot:[`item.inv_list`]="{ item }">
              <div v-for="(val, i) in splitList(item.inv_list)" :key="i" class="inv-line">
                {{ val }}
              </div>
            </template>

            <!-- Invoice / Receipt Status : ขึ้นบรรทัดใหม่แทน comma -->
            <template v-slot:[`item.inv_status_list`]="{ item }">
              <div v-for="(val, i) in splitList(item.inv_status_list)" :key="i" class="inv-line">
                {{ val }}
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon :disabled="!authorize_edit" :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }" @click="openeditItem(item.appointment_id)">
                mdi-pencil
              </v-icon>

              <v-icon :disabled="!authorize_del" class="ml-3" :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-card>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOpenPayment" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 font-weight-bold">
          Select Invoice Create Type
        </v-card-title>
        <v-card-text style="height: auto" class="px-6">
          <v-radio-group v-model="dialogSelectInvType" column>
            <v-radio label="Free Text Proforma Invoice" value="performa" class="mb-2"></v-radio>
            <v-radio label="Free Text Invoice" value="invoice" class="mb-2"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-row no-gutters>
            <v-col cols="6" class="pr-2">
              <v-btn color="#106a94" large rounded dark elevation="0" @click="onSavePayMent" block>
                Create Invoice
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-2">
              <v-btn color="#fc1526" large rounded dark elevation="0" @click="dialogOpenPayment = false" block>
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
import Swal from "sweetalert2";

export default {
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);
    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // await this.loaddataappointmentLimit200();
    await this.loaddatadocumenttype();
    this.$hideLoader();
    // await this.loaddataappointment();
    // this.$showLoader();
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data(vm) {
    const today = new Date();
    const todayStr = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const plus30 = new Date();
    plus30.setDate(today.getDate() + 30);
    const plus30Str = `${String(plus30.getDate()).padStart(2, "0")}/${String(
      plus30.getMonth() + 1
    ).padStart(2, "0")}/${plus30.getFullYear()}`;

    // แปลง DD/MM/YYYY เป็น YYYY-MM-DD สำหรับ DatePicker
    const toYMD = (ddmmyyyy) => {
      const [dd, mm, yyyy] = ddmmyyyy.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      dialogSelectInvType: "invoice",
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      table_id_export_list: "",
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      exportleavequota: "Docket_Trademark.xlsx",
      sheetName: "Docket_Trademark",
      sheets: [
        {
          name: "Docket_Trademark",
          data: [],
        },
      ],
      itemsPerPageArray: [10, 15, 20],
      // page: 1,
      pageSize: 3,
      pageSizes: [3, 6, 9],
      // pageCount: 0,
      // itemsPerPage: 100,
      deletedItem: 0,
      dialogDelete: false,
      searchdatefrom: todayStr,
      searchdateto: plus30Str,
      searchdatefromS: null,
      searchdatetoPicker: toYMD(plus30Str),
      searchdatefromF: "",
      searchdatetoF: "",
      searchdocumenttype: "",
      searchtrademark_name: "",
      searchfile_no: "",
      searchapp_no: "",
      menuadddatefrom: false,
      menuadddateto: false,
      documenttype_list: [],
      isShowPassword: false,
      fullPage: true,
      search: "",
      dateCurrent: vm.formatDateday(new Date().toISOString().substr(0, 10)),
      headers: [
        {
          text: "File No.",
          align: "left",
          value: "refno",
          divider: true,
          width: "100px",
        },
        {
          text: "Application No.",
          value: "app_no",
          divider: true,
          width: "140px",
        },
        {
          text: "Client Name",
          value: "owner_name",
          divider: true,
          width: "200px",
        },
        {
          text: "Agent Reference",
          value: "cliant_ref",
          divider: true,
          width: "100px",
        },
        {
          text: "Agent",
          value: "agent_contact_name",
          divider: true,
          width: "230px",
        },
        {
          text: "Billing Customer",
          value: "cus_name",
          divider: true,
          width: "230px",
        },
        {
          text: "Quotations No.",
          value: "doc_no",
          divider: true,
          width: "230px",
        },
        // {
        //   text: "Quotations Customer",
        //   value: "customer_quotition_name",
        //   divider: true,
        //   width: "230px",
        // },
        {
          text: " Invoice / Receipt No.",
          value: "inv_list",
          divider: true,
          width: "230px",
        },
        {
          text: "Invoice / Receipt Status",
          value: "inv_status_list",
          divider: true,
          width: "230px",
        },

        {
          text: "Work Type",
          align: "left",
          // sortable: true,
          value: "documenttype_code",
          width: "250px",
          divider: true,
        },
        // { text: "Notice Type", value: "notice_name", divider: true },
        {
          text: "Doc Type",
          sortable: false,
          value: "documenttype_actions",
          divider: true,
          width: "300px",
        },
        { text: "Note", value: "user_note", divider: true, width: "100px" },
        {
          text: "Reported / Invioced",
          value: "reportnow",
          divider: true,
          width: "170px",
        },
        {
          text: "Last Updated / Create by",
          value: "last_update",
          divider: true,
          width: "250px",
        },
        { text: "Status", value: "statusnow", divider: true, width: "150px" },
        {
          text: "Deadline Date",
          value: "enddate",
          divider: true,
          width: "150px",
        },
        // { text: "Filed Date", value: "filed_date", divider: true },

        {
          text: "",
          value: "actions",
          width: "100px",
          align: "center",
          divider: true,
        },
      ],
      mDataArray: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      load_bg: false,
      statusSearch: 0,
      statuslist: [
        { status_name: "Pending", status_value: 1 },
        { status_name: "Completed", status_value: 2 },
        { status_name: "Close", status_value: 3 },
        { status_name: "Payment Request", status_value: 4 },
      ],
      excelData: [], // ยังไม่มีข้อมูลตอนเริ่มต้น
      excelFileName: "Docket_Trademark.xlsx",
      oldSearch: {
        searchdocumenttype: "",
        searchtrademark_name: "",
        searchfile_no: "",
        searchapp_no: "",
        searchquotation: "",
        searchdatefrom: null,
        searchdateto: null,
        statusSearch: "",
      },
      selectedItems: [],
      dialogOpenPayment: false,
      searchquotation: "",
    };
  },
  methods: {
    // "INV-001, INV-002" -> ["INV-001", "INV-002"]
    splitList(value) {
      return String(value || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
    onDialogPayMent() {
      this.dialogOpenPayment = true;
    },

    onSavePayMent() {
      var warningAlert = false;
      var warningMessage = "Billing ID or Quotation ID not found or not matching. Please verify the information and try again.";
      var firstBillingId = null;
      var firstQuotationId = null;
      var agentRef = "";
      var fileNoRef = "";
      var cusBilling = "";
      var docketID = "";
      var quotationid = "";

      for (const [index, item] of this.selectedItems.entries()) {
        // เช็คค่าว่างก่อน - cus_billing_id
        if (item.cus_billing_id == null) {
          warningAlert = true;
          break;
        }

        // เช็คค่าว่างก่อน - quotation_id
        if (item.quotation_id == null) {
          warningAlert = true;
          break;
        }

        // ✅ ลูกค้าใน Quotation ต้องตรงกับลูกค้า Billing ของแฟ้ม
        // เทียบด้วย id เพราะชื่ออาจสะกดต่างกันเล็กน้อยแต่เป็นคนเดียวกัน
        if (Number(item.client_id) !== Number(item.cus_billing_id)) {
          warningAlert = true;
          warningMessage = `ใบเสนอราคาเป็นของลูกค้า "${item.customer_quotition_name || "-"}" ซึ่งไม่ตรงกับลูกค้าในแฟ้ม "${item.cus_name || "-"}" (File No. ${item.refno})`;
          break;
        }

        // เก็บตัวแรกไว้เป็นค่าอ้างอิง
        if (index === 0) {
          firstBillingId = item.cus_billing_id;
          firstQuotationId = item.quotation_id;
        }

        // เทียบค่าถัดไปว่าต้องเหมือนกันทุกตัว - cus_billing_id
        if (item.cus_billing_id !== firstBillingId) {
          warningAlert = true;
          break;
        }

        // เทียบค่าถัดไปว่าต้องเหมือนกันทุกตัว - quotation_id
        if (item.quotation_id !== firstQuotationId) {
          warningAlert = true;
          break;
        }
      }

      if (warningAlert) {
        this.dialogOpenPayment = false;
        this.selectedItems = [];
        Swal.fire({
          icon: "warning",
          title: "Warnning Data",
          text: warningMessage,
          showConfirmButton: false,
          timer: 3500,
          timerProgressBar: true,
        });
        return;
      } else {
        if (
          Array.isArray(this.selectedItems) &&
          this.selectedItems.length > 0
        ) {
          cusBilling = this.selectedItems[0].cus_name;
          // agentRef = this.selectedItems[0].cliant_ref ;
          agentRef = this.selectedItems
            .map((item) => item.cliant_ref)
            .filter((ref) => ref != null && ref !== "")
            .join(", ");
          fileNoRef = this.selectedItems
            .map((item) => item.refno)
            .filter((ref) => ref != null && ref !== "")
            .join(", ");
          docketID = this.selectedItems
            .map((item) => item.appointment_id)
            .filter((ref) => ref != null && ref !== "")
            .join(",");
          quotationid = this.selectedItems[0].quotation_id;

        }

        var dataPush = {
          customer_name_master: cusBilling,
          yourRef: "",
          ourRef: "",
          docketId: docketID,
          quotation_id: quotationid
        };

        var custonerId = 0;
        custonerId = this.selectedItems[0].cus_billing_id;

        const hasThai = /[\u0E00-\u0E7F]/;
        if (hasThai.test(cusBilling)) {
          dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${agentRef}`;
          dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${fileNoRef}`;
        } else {
          dataPush.yourRef = `Your Ref: ${agentRef}`;
          dataPush.ourRef = `Our Ref: ${fileNoRef}`;
        }
        if (agentRef.trim() == "") {
          dataPush.yourRef = "";
        }
        this.dialogOpenPayment = false;
        if (this.dialogSelectInvType == "invoice") {
          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
            query: dataPush,
          });
        } else if (this.dialogSelectInvType == "performa") {
          this.$router.push({
            path: `/new-free-invoice/0/performa/D/${custonerId}/Docket`,
            query: dataPush,
          });
        }
      }
    },
    async exportExcel() {
      var number = this.itemsPerPage * this.pageCount;
      if (number > 10000) {
        Swal.fire({
          icon: "warning",
          title: "export ไม่สำเร็จ",
          text: "ข้อมูลมากเกินไป",
          showConfirmButton: false, // ❌ ไม่แสดงปุ่ม OK
          timer: 2000, // ⏱ แสดง 2 วินาทีแล้วปิดเอง
          timerProgressBar: true, // แถบเวลานับถอยหลัง (optional)
        });
      } else {
        this.$showLoader();
        // await this.onSearchPagination()
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },

    async setexporttoxlsx() {

      var resdata = await api.loadDataExportTm(
        this.oldSearch.searchdocumenttype,
        this.oldSearch.searchtrademark_name,
        this.oldSearch.searchfile_no,
        this.oldSearch.searchapp_no,
        this.oldSearch.searchdatefrom,
        this.oldSearch.searchdateto,
        this.oldSearch.statusSearch
      );
      if (resdata.status == 201) {
        const dataAll = resdata.data;
        var dataList = [];
        dataAll.forEach((item, index) => {
          dataList.push({
            WorkType: item.documenttype_code,
            FileNo: item.refno,
            ApplicationNo: item.app_no,
            TrademarkName: item.trademark_name,
            Owner: item.owner_name,
            Agent: item.agent_contact_name,
            FinalDate:
              item.FinalDate && item.FinalDate !== "0000-00-00"
                ? item.FinalDate
                : "",
            Status: item.statusnow,
          });
        });
        const prefix = [{}, {}];
        this.excelData = [...prefix, ...dataList];
      }
    },

    onChange(wb) {
      const ws = wb.Sheets.Docket_Trademark;
      if (!ws) return;

      // ✅ รวมเซลล์ A1 ถึง H1
      ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

      // ✅ ตั้งหัวเรื่องใหญ่
      ws["A1"] = {
        t: "s",
        v: `Export Trademark Docket as of ${this.dateCurrent}`,
      };

      // ✅ ตั้งชื่อคอลัมน์
      ws["A3"] = { t: "s", v: "Work Type" };
      ws["B3"] = { t: "s", v: "File No" };
      ws["C3"] = { t: "s", v: "Application No" };
      ws["D3"] = { t: "s", v: "Trademark Name" };
      ws["E3"] = { t: "s", v: "Owner" };
      ws["F3"] = { t: "s", v: "Agent" };
      ws["G3"] = { t: "s", v: "Final Deadline" };
      ws["H3"] = { t: "s", v: "Status" };
    },

    onActionChange(item, action, val) {
      this.$showLoader();
      console.log(action.id);
      var dataUpdate = {
        documenttype_follow: 0,
        documenttype_action_id: action.documenttype_action_id,
        appointment_id: item.appointment_id,
        appointment_type: `Trademark`,
      };
      if (val) {
        dataUpdate.documenttype_follow = 1;
      } else {
        dataUpdate.documenttype_follow = 0;
      }

      setTimeout(() => {
        api.updateAppointmentDoctypeActions(dataUpdate).finally(() => {
          this.$hideLoader();
        });
      }, 500);
    },
    startEditingNote(item) {
      this.$set(item, "editing_note", true); // สำหรับ Vue 2 (Vuetify 2)
      // item.editing_note = true // ถ้าเป็น Vue 3 ใช้อันนี้ได้เลย

      this.$nextTick(() => {
        // หา text field ที่เปิดใหม่แล้ว focus
        const field = this.$refs.noteField;
        if (Array.isArray(field)) {
          // ใน v-data-table อาจมีหลายช่อง → เลือกช่องของ row ปัจจุบัน
          const currentField = field.find(
            (f) => f.$el && f.$el.offsetParent !== null
          );
          if (currentField) currentField.focus();
        } else if (field && field.focus) {
          field.focus();
        }
      });
    },

    finishEditingNote(item) {
      // ปิด edit mode
      item.editing_note = false;

      // เรียก API update note
      this.updateNote(item);
    },

    async updateNote(item) {
      this.$showLoader();
      setTimeout(async () => {
        try {
          if (item.user_note) {
            var dataUpdateNote = {
              user_note: item.user_note,
            };
            await api.updateAppointmentData(
              Number(item.appointment_id),
              dataUpdateNote
            );
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.$hideLoader();
        }
      }, 500);
    },
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      try {
        const result = await api.getAllAppointmentPagination(
          1,
          this.itemsPerPage,
          "appointment_id",
          "ASC",
          this.searchdocumenttype,
          this.searchtrademark_name,
          this.searchfile_no,
          this.searchapp_no,
          this.searchdatefrom,
          this.searchdateto,
          null,                     // ✅ status
          this.searchquotation
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        sortDesc = "DESC";
      }
      if (!this.options.sortBy[0]) {
        sortDesc = "ASC";
      }

      var sSearh;
      if (this.statusSearch == 0) {
        sSearh = null;
      } else {
        sSearh = this.statusSearch;
      }

      this.oldSearch.searchdocumenttype = this.searchdocumenttype;
      this.oldSearch.searchtrademark_name = this.searchtrademark_name;
      this.oldSearch.searchfile_no = this.searchfile_no;
      this.oldSearch.searchapp_no = this.searchapp_no;
      this.oldSearch.searchdatefrom = this.searchdatefrom;
      this.oldSearch.searchdateto = this.searchdateto;
      this.oldSearch.statusSearch = sSearh;
      this.oldSearch.searchquotation = this.searchquotation;
      try {
        const result = await api.getAllAppointmentPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.searchdocumenttype,
          this.searchtrademark_name,
          this.searchfile_no,
          this.searchapp_no,
          this.searchdatefrom,
          this.searchdateto,
          sSearh,
          this.searchquotation
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
        this.mDataArray2 = this.mDataArray2.map((item) => {
          let actions = [];
          if (Array.isArray(item.documenttype_actions)) {
            actions = item.documenttype_actions;
          } else if (item.documenttype_actions && item.documenttype_actions.trim() !== "") {
            try {
              const parsed = JSON.parse(item.documenttype_actions);
              actions = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              actions = [];
            }
          }
          return { ...item, documenttype_actions: actions };
        });
        // await this.setexporttoxlsx();
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.options.sortBy = [];
      this.options.sortDesc = [];
      let sortDesc = "";

      var sSearh;
      if (this.statusSearch == 0) {
        sSearh = null;
      } else {
        sSearh = this.statusSearch;
      }
      try {
        const result = await api.getAllAppointmentPagination(
          pageNumber,
          this.itemsPerPage,
          "enddate",
          "ASC",
          this.searchdocumenttype,
          this.searchtrademark_name,
          this.searchfile_no,
          this.searchapp_no,
          this.searchdatefrom,
          this.searchdateto,
          sSearh,
          this.searchquotation
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
        this.mDataArray2 = this.mDataArray2.map((item) => {
          let actions = [];
          if (Array.isArray(item.documenttype_actions)) {
            actions = item.documenttype_actions;
          } else if (item.documenttype_actions && item.documenttype_actions.trim() !== "") {
            try {
              const parsed = JSON.parse(item.documenttype_actions);
              actions = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              actions = [];
            }
          }
          return { ...item, documenttype_actions: actions };
        });
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;
      this.options.sortBy = [];
      this.options.sortDesc = [];

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "enddate",
        sortDesc: "ASC",
        searchdocumenttype: this.searchdocumenttype,
        searchtrademark_name: this.searchtrademark_name,
        searchfile_no: this.searchfile_no,
        searchapp_no: this.searchapp_no,
        searchquotation: this.searchquotation,
        searchdatefrom: this.searchdatefrom,
        searchdateto: this.searchdateto,
      };
      var sSearh;
      if (this.statusSearch == 0) {
        sSearh = null;
      } else {
        sSearh = this.statusSearch;
      }
      this.oldSearch.searchdocumenttype = this.searchdocumenttype;
      this.oldSearch.searchtrademark_name = this.searchtrademark_name;
      this.oldSearch.searchfile_no = this.searchfile_no;
      this.oldSearch.searchapp_no = this.searchapp_no;
      this.oldSearch.searchdatefrom = this.searchdatefrom;
      this.oldSearch.searchdateto = this.searchdateto;
      this.oldSearch.statusSearch = sSearh;
      this.oldSearch.searchquotation = this.searchquotation;

      try {
        const result = await api.getAllAppointmentPagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortDesc,
          s_data.searchdocumenttype,
          s_data.searchtrademark_name,
          s_data.searchfile_no,
          s_data.searchapp_no,
          s_data.searchdatefrom,
          s_data.searchdateto,
          sSearh,
          s_data.searchquotation
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
        this.mDataArray2 = this.mDataArray2.map((item) => {
          let actions = [];
          if (Array.isArray(item.documenttype_actions)) {
            actions = item.documenttype_actions;
          } else if (item.documenttype_actions && item.documenttype_actions.trim() !== "") {
            try {
              const parsed = JSON.parse(item.documenttype_actions);
              actions = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              actions = [];
            }
          }
          return { ...item, documenttype_actions: actions };
        });
        // await this.setexporttoxlsx();
      }
    },

    async export_log() {
      if (this.table_id_export_list != "") {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Export",
          table_name: "appointment",
          table_id: this.table_id_export_list,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );
      }
    },
    onCreated(wb) { },

    async loaddataappointmentLimit200() {
      // this.$showLoader();

      const result = await api.getAllAppointment200();
      console.log(result.data);
      // const result = await api.getAllMasterTM();
      this.mDataArray = result.data;
      await this.setexporttoxlsx();

      // this.$hideLoader();
    },
    async loaddataappointment() {
      const result = await api.getAllAppointment();
      console.log(result.data);
      this.mDataArray = result.data;
      let setexportxlsx = [];
      await this.setexporttoxlsx();
    },
    async onSearchAll() {
      if (this.searchdocumenttype) {
        this.onSelectdocumenttype();
      } else if (this.searchtrademark_name) {
        this.onSearchtrademark_name();
      } else if (this.searchfile_no) {
        this.onSearchfile_no();
      } else if (this.searchapp_no) {
        this.onSearchapp_no();
      }
    },
    async onSelectdocumenttype(data) {
      this.$showLoader();
      this.searchtrademark_name = "";
      this.searchfile_no = "";
      this.searchapp_no = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      console.log(this.searchdocumenttype);
      const result = await api.searchdataAppointment({
        params: {
          searchdocumenttype: this.searchdocumenttype,
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchtrademark_name() {
      this.$showLoader();
      this.searchfile_no = "";
      this.searchapp_no = "";
      this.searchdocumenttype = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      const result = await api.searchdataAppointment({
        params: {
          searchtrademark_name: this.searchtrademark_name.trim(),
          searchdatefrom: this.searchdatefrom,
          searchdateto: this.searchdateto,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchfile_no() {
      this.$showLoader();
      this.searchapp_no = "";
      this.searchtrademark_name = "";
      this.searchdocumenttype = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      const result = await api.searchdataAppointment({
        params: {
          searchfile_no: this.searchfile_no.trim(),
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchapp_no() {
      this.$showLoader();
      this.searchfile_no = "";
      this.searchtrademark_name = "";
      this.searchdocumenttype = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      const result = await api.searchdataAppointment({
        params: {
          searchapp_no: this.searchapp_no.trim(),
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchdatefrom() {
      this.$showLoader();
      // this.searchfile_no = "";
      // this.searchtrademark_name = "";
      // this.searchdocumenttype = "";
      // this.searchapp_no = "";
      if (!this.searchdatetoF) {
        this.$hideLoader();
        return;
      }
      const result = await api.searchdataAppointment({
        params: {
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
          searchfile_no: this.searchfile_no,
          searchtrademark_name: this.searchtrademark_name,
          searchdocumenttype: this.searchdocumenttype,
          searchapp_no: this.searchapp_no,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchdateto() {
      this.$showLoader();
      // this.searchfile_no = "";
      // this.searchtrademark_name = "";
      // this.searchdocumenttype = "";
      // this.searchapp_no = "";
      if (!this.searchdatefromF) {
        this.$hideLoader();
        return;
      }
      const result = await api.searchdataAppointment({
        params: {
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
          searchfile_no: this.searchfile_no,
          searchtrademark_name: this.searchtrademark_name,
          searchdocumenttype: this.searchdocumenttype,
          searchapp_no: this.searchapp_no,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async SearchAll() {
      this.$showLoader();
      const result = await api.searchdataAppointment({
        params: {
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
          searchfile_no: this.searchfile_no,
          searchtrademark_name: this.searchtrademark_name,
          searchdocumenttype: this.searchdocumenttype,
          searchapp_no: this.searchapp_no,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async loaddatadocumenttype() {
      const result = await api.getdocumenttype_code();
      // console.log(result.data);
      this.documenttype_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async openAppointmentadd() {
      let file_no = " ";
      let date_of_renewal = "null";
      localStorage.setItem(server.MODELMENU, 6);
      this.$router.push(`/appointmenttm-add/${file_no}/${date_of_renewal}`);
    },
    async openeditItem(appointment_id) {
      // this.$router.push(`/appointmenttm-edit/${appointment_id}`);
      window.open(`/appointmenttm-edit/${appointment_id}`);
    },
    deleteItem(item) {
      this.deletedIndex = this.mDataArray.indexOf(item);
      console.log(item.appointment_id);
      this.deletedItem = item.appointment_id;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deletedItem = 0;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.$showLoader();
      this.mDataArray.splice(this.deletedIndex, 1);
      this.dialogDelete = false;
      // let setflag = 0;
      // // 0 = delete
      // const resdel = await api.AppointmentUpdate(this.deletedItem, {
      //   ocr_flag: setflag,
      // });
      const resdel = await api.AppointmentDeleteMode(this.deletedItem);
      console.log(resdel);
      if (resdel.status == 200) {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Delete",
          table_name: "appointment",
          table_id: this.deletedItem,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialog(
          true,
          "delete data",
          "delete data success",
          "text-h5 green--text text-center"
        );
        return;
      } else {
        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "delete data",
          "can't delete data",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    formatDateToDMY(dateStr) {
      // ตรวจสอบว่าเป็นรูปแบบ yyyy-mm-dd
      const [yyyy, mm, dd] = dateStr.split("-");
      if (!yyyy || !mm || !dd) return "";
      return `${dd}/${mm}/${yyyy}`;
    },

    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  watch: {
    searchdatefromF(val) {
      this.searchdatefrom = this.formatDate(this.searchdatefromF);
    },
    searchdatetoF(val) {
      this.searchdateto = this.formatDate(this.searchdatetoF);
    },
    excelData(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.xlsxDownload) {
            this.$refs.xlsxDownload.download();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--default.btnimport {
  background-color: #ffffff;
  color: #25b360;
}

.v-btn:not(.v-btn--round).v-size--default.btnexport {
  background-color: #ffffff;
  color: #33a4c0;
}

h3 {
  font-size: 1.17em;
}

.inv-line {
  line-height: 22px;
  white-space: nowrap;
}
</style>
